import { EXTERNAL_MERCHANT_PREFIX } from 'config';
import { MERCHANT_TYPES } from './MerchantContext';

const useMerchantProvider = () => {
	let merchantName: string = MERCHANT_TYPES.EXTERNAL;
	const currentLocation: string = window.location.href;
	if (EXTERNAL_MERCHANT_PREFIX.includes('matrix')) {
		merchantName = MERCHANT_TYPES.MARKETING;
	} else if (!currentLocation.includes(EXTERNAL_MERCHANT_PREFIX)) {
		merchantName = MERCHANT_TYPES.ZUPEE;
	}

	return {
		merchantName
	};
};

export default useMerchantProvider;
